const ONB_BANK_ACCOUNT_OPEN_PATH = '';
const ONB_ROBO_PATH = 'inversion-automatizada';

export default {
    ONB_BANK_ACCOUNT_OPEN_PATH,
    ONB_ROBO_PATH,
};
